import { METHODS, createAsyncAction } from 'api';
import { MICROSERVICES_NAMES } from 'api/types';
import axios from 'axios';
import { USProductOffer } from 'types';

export const fetchProducts = async (): Promise<Array<USProductOffer>> => {
  try {
    const response = await createAsyncAction(
      'en-US',
      MICROSERVICES_NAMES.VARIFY,
      'varify.products',
      METHODS.POST,
      {
        params: {
          query: `query ProductOffersTypes {
                productOffers {
                    nodes {
                        id
                        type
                        name
                        apy
                        minAmount
                        maturity {
                            unit
                            duration
                        }
                        productBank {
                            id
                            name
                            logoUrl
                        }
                    }
                }
            }`,
        },
      },
    );

    return response?.data?.productOffers?.nodes ?? [];
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('Axios request failed:', {
        message: error.message,
        isAxiosError: error.isAxiosError,
        url: error.config?.url,
        data: error.toJSON?.(),
      });
    }
    return [];
  }
};
